export class AgendaEventAutoGeneratedLabelModel {
    includePartnerName: boolean;
    includeEmail: boolean;
    includePhone: boolean;
    includeCategoryLabel: boolean;
}